<template>
  <div class="panel-body border-bottom">
    <div>

      <div class="mb-3">
        <app-question-editor class="mt-2"
                             :data-show-label="false"
                             :data-interaction="interactionStored"
                             :question="true"
                             @change="(evt) => $emit('update', evt)"></app-question-editor>
      </div>

      <template v-for="(option, index) in interactionStored.opcoes">
        <app-poll-option :data-index="index + 1"
                         :value="option"
                         :key="index"
                         :interaction="interactionStored"
                         @reload="emitReload"
                         @remove="$emit('remove-option', option)"
                         @change="(evt) => $emit('update-option', {option, data: {nome: evt}})"
                         @change-auth="(evt) => $emit('update-option', {option: interactionStored.opcoes[index], data: {paginaPosAutenticacao: evt}})">
        </app-poll-option>
      </template>

      <div class="add-option"
           v-if="interactionStored.opcoes.length < 6">
        <i class="mdi mdi-plus-circle-outline pointer"
           @click="$emit('add-option')"></i>
        <span class="text-bold">{{$t('message.campaigns.message.addOption')}}</span>
      </div>

      <app-option-editor :data-show-label="false"
                         :data-interaction="interactionStored"
                         @reload="emitReload"
                         @change-auth="(evt) => $emit('update-option', {option: interactionStored.opcoes[0], data: {paginaPosAutenticacao: evt}})">
      </app-option-editor>

    </div>
  </div>
</template>

<script>
    import AppQuestionEditor from './QuestionEditor'
    import AppOptionEditor from './OptionEditor'
    import AppPollOption from './PollOption'
    import panelBody from '../mixins/panel-body'
    import EventBus from '@packages/event-bus'


    export default {
        components: {
            AppOptionEditor,
            AppPollOption,
            AppQuestionEditor,
        },

        mixins: [panelBody],

        methods: {
            removeOption(option) {
                if(this.interaction.opcoes.length <= 2) {
                    return EventBus.$emit('show-message', {
                        type: 'ERROR',
                        message: this.$t('message.errorMessages.message.atLeastTwoOptions')
                    })

                }

                this.$emit('remove-option', option)
            },
            emitReload() {
              this.$emit('reload')
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../mixins/panel-body";

.add-option {
  .mdi {
    margin-right: 6px;
  }
}
</style>
